import logo from '../assets/images/paroc-logo.jpg';

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';


import { openLogin } from '../modules/app';

import { logOut } from '../modules/user';

import { url } from '../utils/user';

import { getUIText } from '../utils/index';

import { adobeClickBecomeRegisterUser } from '../utils/analytics';


class Header extends Component {

  state = {
    open: false,
    anchorEl: undefined,
  }

  componentDidUpdate(_, prevState) {
    if (this.state.open && !prevState.open) {
      setTimeout(() => {
        if (this.state.open) {
          document.addEventListener('mousedown', this.handleClickOutside);
        }
      }, 0);
    } else if (!this.state.open && prevState.open) {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClick = event => {
    event.stopPropagation();
    if (this.state.open) {
      this.handleRequestClose();
    } else {
      this.setState({ open: true, anchorEl: event.currentTarget });
    }
  }

  handleRequestClose = () => {
    this.setState({ open: false, anchorEl: undefined });
  }

  handleClickOutside = (event) => {
    const { anchorEl } = this.state;
    const menuEl = document.getElementById('simple-menu');

    if (anchorEl && anchorEl.contains(event.target)) {
      return;
    }
    if (menuEl && menuEl.contains(event.target)) {
      return;
    }

    this.handleRequestClose();
  }

  handleMenuItemClick = (action) => (event) => {
    event.stopPropagation();
    this.handleRequestClose();
    action();
  }

  onLogOut = (logout_token) => {
    this.props.onLogOut({logout_token: logout_token});
  }

  handleClickBecomeRegisterUser = () => {
    const {
      app,
      translations,
    } = this.props;
    adobeClickBecomeRegisterUser(getUIText('GENERAL-BECOME_REGISTER_USER', app.language, translations), getUIText('GENERAL-BECOME_REGISTER_USER', 'English', translations));
  }

  userDetails = () => {
    const {
      user,
     } = this.props;

    const {
      uid
    } = user ? user : {};

    const win = window.open(url + '/user/' + uid + '/edit', '_blank');
    win.focus();
  }

  render() {
    const {
      user,
      translations,
      app,

      onOpenLogin
     } = this.props;
    const { username, logInProgress, logout_token } = user ? user : {};

    return (
      <div className="header">
        <div className="m-container">
          <Link to="/">
            <img className="logo" src={logo} />
          </Link>
          <h1 className="header-h1">PAROC Calculus</h1>
          <nav>
            {username
              ?
              <div className="login-register-container">
                <div className="login">
                  <div className="login-dropdown">
                    <a
                      className="login"
                      aria-owns={this.state.open ? 'simple-menu' : null}
                      aria-haspopup="true"
                      onClick={this.handleClick}
                    >
                      {username}
                    </a>
                    <Menu
                      id="simple-menu"
                      anchorEl={this.state.anchorEl}
                      open={this.state.open}
                      onClose={this.handleRequestClose}
                      style={{ zIndex: 1700 }}
                      getContentAnchorEl={null}
                      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    >
                      <MenuItem onClick={this.handleMenuItemClick(this.userDetails)}>{getUIText('GENERAL-EDIT_PROFILE', app.language, translations)}</MenuItem>
                      <MenuItem onClick={this.handleMenuItemClick(() => this.onLogOut(logout_token))}>{getUIText('GENERAL-LOG_OUT', app.language, translations)}</MenuItem>
                    </Menu>
                  </div>
                </div>
              </div>
              :
                logInProgress
                  ? <div className="login-register-container">
                      <a className="login">{getUIText('GENERAL-LOGGING_IN', app.language, translations)}</a>
                    </div>
                  : <div className="login-register-container">
                  <a className="login" onClick={onOpenLogin}>{getUIText('GENERAL-SIGN_IN', app.language, translations)}</a>
                     <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                      {/* <a className="register" href="http://form.paroc.com/cn/afgpo/CalculusConsentINT" >{getUIText("GENERAL-BECOME_REGISTER_USER", app.language, translations)}</a> */}
                      <a className="register" target="_blank" href="https://analytics-eu.clickdimensions.com/paroccom-afgpo/pages/du5hl7qeeibsnaqb6bymq.html?PageId=fe474e75d05ee811814a70106fa6d831" onClick={this.handleClickBecomeRegisterUser.bind(this)}>{getUIText('GENERAL-BECOME_REGISTER_USER', app.language, translations)}</a>
                    </div>
            }

          </nav>
        </div>
      </div>
    );
  }
}

Header.propTypes = {
    user: PropTypes.object,
    translations: PropTypes.object,
    app: PropTypes.object,
  onLogOut: PropTypes.any,
  onOpenLogin: PropTypes.any,
};

const mapStateToProps = (state) => {
    return {
        user: state.user,
        translations: state.translations,
        app: state.app,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onOpenLogin: () => dispatch(openLogin()),
        onLogOut: (item) => dispatch(logOut(item)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Header);
